// extracted by mini-css-extract-plugin
export default {"languageSelect":"styles_languageSelect__HZDMt"};